Service = App.loadClass 'core::Angular/Service'

class exports.ManageUsersService extends Service
    constructor: (@http, @rootScope) ->
        undefined

    getUsers: () =>
        @http.post 'backend/admin/new-tools/manage-users/get-users'

    getUserCompanies: (user_id) =>
        @http.post 'backend/admin/new-tools/manage-users/get-user-companies',
            user_id: user_id

    updateUserCompanies: (user_id, company_ids) =>
        @http.post 'backend/admin/new-tools/manage-users/update-user-companies',
            user_id: user_id
            company_ids: company_ids

    viewAccountInfo: (user_id) =>
        @http.post 'backend/admin/new-tools/manage-users/view-account-info',
            user_id: user_id

    editContactInfo: (user_id) =>
        @http.post 'backend/admin/new-tools/manage-users/edit-contact-info',
            user_id: user_id

    updateContactInfo: (user) =>
        @http.post 'backend/admin/new-tools/manage-users/update-contact-info',
            user: user

    editRoles: (user_id) =>
        @http.post 'backend/admin/new-tools/manage-users/edit-roles',
            user_id: user_id

    updateRoles: (user, companies_users) =>
        @http.post 'backend/admin/new-tools/manage-users/update-roles',
            user_id: user.id
            is_myfarms_employee: user.is_myfarms_employee
            on_payroll: user.on_payroll
            companies_users: companies_users

    changeActivity: (user_id, activate) =>
        @http.post 'backend/admin/new-tools/manage-users/change-activity',
            user_id: user_id
            activate: activate

    deleteUser: (user_id) =>
        @http.post 'backend/admin/new-tools/manage-users/delete-user',
            user_id: user_id
